import { CmsAdList } from '../../../../components/Cms';

export function CmsAds() {
  return <CmsAdList />;
}
